import { gql } from '@apollo/client';

import { meetingFieldsFragment } from '@repositories/clubs/queries';

export const fetchClubDetailsQuery = gql`
  query fetchClubDetails(
    $clubId: String!
    $termStartYear: Int
    $dominoId: String
  ) {
    club: clubById(clubId: $clubId, dominoId: $dominoId) {
      riClubId
      clubName
      clubType
      organizationBase
      district
      districtId
      charteredDate
      primaryFax {
        number
        extension
        countryId
      }
      primaryEmail
      primaryPhone {
        number
        extension
        countryId
      }
      primaryWebsite
      officialLanguage {
        name
      }
      mailingAddress {
        lineOne
        lineTwo
        lineThree
        country
        countryId
        city
        state
        stateId
        postalCode
      }
      physicalLocation {
        state
        internationalProvince
        country
      }
      leaders(termStartYear: $termStartYear) {
        primaryEmail
        individualName
        startDate
        endDate
        role {
          name
        }
        individualId
        photoUri
      }
      childClubRelationships {
        id
        clubName
        childClubId
        childDisId
        type
        endDate
      }
      parentClubRelationships {
        id
        clubName
        parentClubId
        parentDisId
        type
        endDate
      }
      meetings {
        ...MeetingFields
      }
      operationsAccess {
        club
        memberships
        leaderships
        financesGoalsReports
      }
      vendors {
        vendorName
        startDate
      }
    }
  }
  ${meetingFieldsFragment}
`;
